module.exports = __webpack_public_path__ + "static/fairchance_sec2_obj2@2x-fea4745836b9d5dadd7f1dd04890e633.png";